import React from 'react';
import { useHistory } from 'react-router';

import RoutePaths from '@app/routes/paths';
import useGenerateRoutePath from '@app/routes/paths/useGenerateRoutePath';

import { Grid, Typography } from '@mui/material';

import ArrowRightIcon from 'jsx:@assets/svgs/arrowRight.svg';

import { ActionItem } from './styles';

function UserExistsPage() {
	const history = useHistory();
	const generateRoutePath = useGenerateRoutePath();

	return (
		<>
			<Grid container direction="column" alignItems="center" justifyContent="center">
				<Typography variant="body1" mb={2}>
					<b>A user already exists with the same email or phone.</b>
				</Typography>

				<Grid container>
					<Grid item xs={12} mb={2}>
						<ActionItem onClick={() => history.push(generateRoutePath(RoutePaths.AUTH.LOGIN))}>
							<Grid item display={'flex'} alignItems={'center'} justifyContent={'center'}>
								<Typography variant="caption" ml={1}>
									<b>Login</b>
								</Typography>
							</Grid>

							<ArrowRightIcon />
						</ActionItem>
					</Grid>

					<Grid item xs={12} mb={2}>
						<ActionItem onClick={() => history.push(generateRoutePath(RoutePaths.AUTH.FORGOT_PASSWORD_METHOD))}>
							<Grid item display={'flex'} alignItems={'center'} justifyContent={'center'}>
								<Typography variant="caption" ml={1}>
									<b>Reset Password</b>
								</Typography>
							</Grid>

							<ArrowRightIcon />
						</ActionItem>
					</Grid>
				</Grid>
			</Grid>
		</>
	);
}

export default UserExistsPage;
